import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { AnalyticsProvider } from '@core/utils/analytics';
import { AccountProvider } from '@core/utils/auth';
import { FeatureFlagsProvider } from '@core/utils/flags';
import { PreferencesProvider } from '@core/utils/prefs';
import { App } from './App';
import { ThemePrefsProvider } from './theme/ThemePrefsProvider';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AccountProvider>
        <PreferencesProvider>
          <ThemePrefsProvider>
            <FeatureFlagsProvider>
              <AnalyticsProvider>
                <App />
              </AnalyticsProvider>
            </FeatureFlagsProvider>
          </ThemePrefsProvider>
        </PreferencesProvider>
      </AccountProvider>
    </BrowserRouter>
  </StrictMode>,
);
